/**
 * コレクションテキストセクション
 * メタフィールドのHTMLをJSで挿入
 */

/**
 * 上部テキストを挿入
 */
const initTopText = (): void => {
  const topTextElement = document.querySelector(
    "[data-collection-top-text]",
  ) as HTMLElement;
  if (!topTextElement) return;

  const htmlContent = topTextElement.getAttribute("data-collection-top-text");
  if (htmlContent) {
    topTextElement.innerHTML = htmlContent;
  }
};

/**
 * 下部テキストを挿入
 */
const initBottomText = (): void => {
  const bottomTextElement = document.querySelector(
    "[data-collection-bottom-text]",
  ) as HTMLElement;
  if (!bottomTextElement) return;

  const htmlContent = bottomTextElement.getAttribute(
    "data-collection-bottom-text",
  );
  if (htmlContent) {
    bottomTextElement.innerHTML = htmlContent;
  }
};

/**
 * コレクションテキストセクションを初期化
 */
export const collectionText = (): void => {
  initTopText();
  initBottomText();
};
